export default "__VITE_ASSET__7f7c6515__"